import React, { Component } from "react";

import PropTypes from "prop-types";

class PontoInteresse extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    
    this.state = {
    }

  }

  POIClicked = () => {
    this.props.POIClicked(this.props.ponto.id);
  }

  render() {
    const sectionStyle = {
      width: "100%",
      backgroundImage: "url(" + this.props.ponto.mainPhoto + ")",
      backgroundSize: "cover",
      backgroundPosition: "center",
      opacity: 1,
      transition: "all .8s",
    };


    return (
      <div id="ponto-interesse" className="col-6 col-md-3">
        <div onClick={this.POIClicked} className="div-to-move" style={sectionStyle}>
          
            <div className="ponto-interesse" />
            <div className="ponto-interesse-conteudo">
              <p>{this.props.ponto.name}</p>
            </div>
          
        </div>
      </div>
    );
  }
}

export default PontoInteresse;
